import { Link } from "react-router-dom";
import { Seo } from "../components/site/Seo";

export default function NotFoundPage() {
  return (
    <section data-testid="not-found-page" className="grid min-h-[80vh] place-items-center bg-paper px-6 pt-24">
      <Seo title="Página não encontrada | Mega Solar" description="A página que procura não existe." path="/404" noindex />
      <div className="text-center">
        <p className="font-display text-8xl font-semibold tracking-tighter text-gold-ink">404</p>
        <h1 className="mt-4 font-display text-3xl font-semibold tracking-tight text-forest">Página não encontrada</h1>
        <Link to="/" className="btn-gold mt-8" data-testid="not-found-home-link">Voltar ao início</Link>
      </div>
    </section>
  );
}
